import api from '../api';

// Mock data functions at the top (following existing pattern)
const getMockSettingsData = () => {
  return {
    on_boarding_process: {
      value: "onboarding_process.pdf",
      exists: true,
      s3_key: "documents/onboarding_process.pdf"
    },
    hand_back_process: {
      value: "handback_process.pdf",
      exists: true,
      s3_key: "documents/handback_process.pdf"
    }
  };
};

const getMockEmailSettingsData = () => {
  return {
    email_about_dismissed_guardian: "dismissed_guardian@example.com",
    email_about_initial_inspection_report: "inspection_report@example.com"
  };
};

const settingsService = {
  // Get general settings data
  getSettings: async () => {
    try {
      console.log("Fetching settings data");
      const response = await api.get('/settings');
      console.log("Settings response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching settings:", error);
      console.log("Falling back to mock data");
      return {
        success: true,
        data: getMockSettingsData()
      };
    }
  },

  // Update general settings
  updateGeneralPropertyDocuments: async (data) => {
    try {
      console.log("Updating general property documents:", data);
      const response = await api.put('/settings/general-property-documents', data);
      console.log("Update response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating general property documents:", error);
      console.log("Falling back to mock success");
      return {
        success: true,
        message: "Settings updated successfully (mock)"
      };
    }
  },

  // Get email settings
  getEmailSettings: async () => {
    try {
      console.log("Fetching email settings");
      const response = await api.get('/settings/email');
      console.log("Email settings response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching email settings:", error);
      console.log("Falling back to mock data");
      return {
        success: true,
        data: getMockEmailSettingsData()
      };
    }
  },

  // Update email settings
  updateEmailSettings: async (data) => {
    try {
      console.log("Updating email settings:", data);
      const response = await api.put('/settings/email', data);
      console.log("Email update response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating email settings:", error);
      console.log("Falling back to mock success");
      return {
        success: true,
        message: "Email settings updated successfully (mock)"
      };
    }
  },

  // Get document by name
  getDocumentByName: async (name) => {
    try {
      console.log("Getting document by name:", name);
      const response = await api.get(`/settings/document/${encodeURIComponent(name)}`);
      console.log("Document response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error getting document:", error);
      throw error;
    }
  },

  // Helper method to get mock data for testing
  getMockSettingsData,
  getMockEmailSettingsData
};

export default settingsService; 